import { render, staticRenderFns } from "./dataCard.vue?vue&type=template&id=a3c66958&scoped=true"
import script from "./dataCard.vue?vue&type=script&lang=js"
export * from "./dataCard.vue?vue&type=script&lang=js"
import style0 from "./dataCard.vue?vue&type=style&index=0&id=a3c66958&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c66958",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3c66958')) {
      api.createRecord('a3c66958', component.options)
    } else {
      api.reload('a3c66958', component.options)
    }
    module.hot.accept("./dataCard.vue?vue&type=template&id=a3c66958&scoped=true", function () {
      api.rerender('a3c66958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/dataCard.vue"
export default component.exports